gsap.registerPlugin(ScrollTrigger);

class Farbwechsler {
    constructor({ trigger, text, containerText, slider, buttons }) {
        this.trigger = trigger ? document.querySelector(trigger) : null;
        this.text = text ? document.querySelector(text) : null;
        this.containerText = containerText ? document.querySelector(containerText) : null;
        this.slider = slider ? document.querySelector(slider) : null;
        this.sliderInstance = this.slider ? ScrollTrigger.getById('slider') : null;
        this.buttons = buttons ? document.querySelectorAll(buttons) : null;
    }

    get textTop() {
        return (this.text.getBoundingClientRect().top);
    }
    get containerTextHeight() {
        return (this.containerText.getBoundingClientRect().height);
    }

    farbeWechselnTextMitContainer() {
        console.log('farbeWechselnTextMitContainer');
        if (!this.trigger || !this.text || !this.containerText) return;

        if (this.sliderInstance) {
            gsap.timeline({
                scrollTrigger: {
                    trigger: this.trigger,
                    pinnedContainer: '.projekt__projekte',
                    start: () => `${(this.textTop + this.containerTextHeight) * -1} top`,
                    end: () => `${(this.textTop) * -1} top`,
                    scrub: true,
                    invalidateOnRefresh: true,
                }
            }).to(this.containerText, {
                immediateRender: true,
                ease: 'none',
                backgroundPositionY: '100%'
            }, 0);
        } else {
            gsap.timeline({
                scrollTrigger: {
                    trigger: this.trigger,
                    start: () => `${((this.textTop + this.containerTextHeight)) * -1} top`,
                    end: () => `${(this.textTop) * -1} top`,
                    scrub: true,
                    invalidateOnRefresh: true,
                }
            }).to(this.containerText, {
                immediateRender: true,
                ease: 'none',
                backgroundPositionY: '100%'
            }, 0);
        }
    }

    farbeWechselnText() {
        console.log('farbeWechselnText');
        if (!this.trigger || !this.buttons) return;

        if (this.sliderInstance) {

            this.buttons.forEach((button) => {
                gsap.to(button, {
                    scrollTrigger: {
                        trigger: this.trigger,
                        pinnedContainer: '.projekt__projekte',
                        start: () => `${(button.getBoundingClientRect().top + button.getBoundingClientRect().height) * -1} top`,
                        end: () => `${(button.getBoundingClientRect().top) * -1} top`,
                        scrub: true,
                        invalidateOnRefresh: true,
                    },
                    backgroundPositionY: '100%',
                    ease: 'none',
                });
            });
        } else {
            this.buttons.forEach((button) => {
                gsap.to(button, {
                    scrollTrigger: {
                        trigger: this.trigger,
                        start: () => `${(button.getBoundingClientRect().top + button.getBoundingClientRect().height) * -1} top`,
                        end: () => `${(button.getBoundingClientRect().top) * -1} top`,
                        scrub: true,
                        invalidateOnRefresh: true,
                    },
                    backgroundPositionY: '100%',
                    ease: 'none',
                });
            });
        }
    }


    killTimeline() {
        if (this.timeline) {
            this.timeline.kill();
            this.timeline = null;
        }
    }
}